<div *ngIf="!loadingComplete" class="spinner-div gbl-div">
    <mat-spinner class="spinner-cls gbl-cls"></mat-spinner>
</div>
<div class="section-gap" > <!-- *ngIf="showResults"-->
  <div class="submit-title submit-title-typography">Submitted Applications</div>
  
    <mat-tab-group animationDuration="0ms" (selectedTabChange)="selectAppTypeChange($event)" class="apps-tab-class">
      <mat-tab *ngFor="let appType of appTypes">
        <ng-template mat-tab-label>
          <span class="section-tab-title">{{appType}}</span>
        </ng-template>
        <ng-template matTabContent>
          <div class="submitted-applications-table-container" *ngIf="applicationsList && applicationsList.length > 0">
            <div *ngIf="!isMobileDeviceSize">
            <table id="submittedApplicationsTable" class="submitted-applications-table" matSort (matSortChange)="sortChangeUpdate($event)">
            <caption>
                  <mat-paginator #appPaginator
                      [length]="totalItems"
                      [pageSize]="pageSize"
                      [pageSizeOptions]="[5, 10, 20]"
                      showFirstLastButtons
                      (page)="onPageChange($event)">
                  </mat-paginator>
              </caption>
              <thead>
                <tr class="apps-table-header-layout apps-table-header-style">
                  <th class="app-table-columns submitted-app-table-form-type-col" mat-sort-header="formType" sortActionDescription="Sort by Form Type"><span>Form</span></th>
                  <th class="app-table-columns submitted-app-table-names-col" mat-sort-header="suggestedNamesText" sortActionDescription="Sort by Suggested names" ><span>Suggested / Revised Names</span></th>
                  <th class="app-table-columns submitted-app-table-submitted-col" mat-sort-header="submittedDate" sortActionDescription="Sort by Date"><span>Date Submitted</span></th>
                  <th class="app-table-columns submitted-app-table-negotiator-col" mat-sort-header="negotiator" sortActionDescription="Sort by Negotiator"><span>Negotiator</span></th>
                  <th *ngIf="appType.includes('Approved')" class="app-table-columns submitted-app-table-status-col" mat-sort-header="status" sortActionDescription="Sort by Status"><span>Status</span></th>
                  <th class="app-table-columns submitted-app-table-progress-col"><span>Progress</span></th>
                  <th class="app-table-columns submitted-app-table-view-col "><span>View</span></th> 
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let app of paginatedSubmittedAppl" class="apps-table-value-layout apps-table-value-style">
                  <td class="app-table-columns submitted-app-table-form-type-col submitted-app-left-aligned">
                    <span class="form-name-outer"><span style="padding-left: 15px;">{{ parseFormType(app.formType) }}</span></span>
                  </td>
                  <td class="app-table-columns submitted-app-table-names-col submitted-app-data-col">
                    {{ app.suggestedNamesText }}
                  </td>
                  <td class="app-table-columns submitted-app-table-submitted-col submitted-app-data-col">
                    {{ app.submittedDate }}
                  </td>
                  <td class="app-table-columns submitted-app-table-negotiator-col submitted-app-data-col">
                    {{ app.negotiator }}
                  </td>
                  <td *ngIf="appType.includes('Approved')" class="app-table-columns submitted-app-table-status-col submitted-app-data-col">
                    {{ app.status }}
                  </td>
                  <td class="app-table-columns submitted-app-table-progress-col padding-top-5">
                    <span class="submitted-app-table-progress-container">
                      <mat-progress-spinner mode="determinate" [value]="100" [diameter]="24" [strokeWidth]="4" class="submitted-app-icon app-progress-icon submitted-app-status-spinner-base"></mat-progress-spinner>
                      <mat-progress-spinner mode="determinate" [value]="app.progressValue" [diameter]="24" [strokeWidth]="4" class="submitted-app-icon app-progress-icon submitted-app-status-spinner-progress"></mat-progress-spinner>
                    </span>
                  </td>
                  <td class="app-table-columns submitted-app-table-view-col padding-top-5">
                    <button class="submitted-app-btn" (click)="viewSubmittedApplication(app)">
                      <mat-icon class="submitted-app-icon">visibility</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            <div *ngIf="isMobileDeviceSize" class="submitted-applications-mobile">
              <mat-paginator
                [length]="totalItems"
                [pageSize]="pageSize"
                [pageSizeOptions]="[5, 10, 20]"
                  [showFirstLastButtons]="false"
                (page)="onPageChange($event)">
              </mat-paginator>
              <ng-container *ngFor="let app of paginatedSubmittedAppl">
                <div class="submitted-app-mobile">
                  <div class="submitted-app-mobile-style">
                    <div class="submitted-app-mobile-info">
                      <span class="submitted-app-mobile-form-text">
                        {{ app.formType }}
                      </span>
                      <span class="submitted-app-mobile-details-text">
                        {{ app.submittedDetailsText }}
                      </span>
                    </div>
                    <div class="submitted-app-icon-list">
                      <span class="submitted-app-mobile-progress-container">
                        <mat-progress-spinner mode="determinate" [value]="100" [diameter]="24" [strokeWidth]="4"
                          class="submitted-app-mobile-icon app-progress-icon submitted-app-status-spinner-base "></mat-progress-spinner>
                        <mat-progress-spinner mode="determinate" [value]="app.progressValue" [diameter]="24" [strokeWidth]="4"
                          class="submitted-app-mobile-icon app-progress-icon submitted-app-status-spinner-progress"></mat-progress-spinner>
                      </span>
                      <button (click)="viewSubmittedApplication(app)">
                        <mat-icon class="submitted-app-mobile-icon">visibility</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div *ngIf="applicationsList?.length === 0">
            <br><br>No Applications found.
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
</div>